import ObserverTracker from '../observer';

const ObserverTrackerComponent = {
  name: 'ObserverTracker',

  props: {
    options: {
      type: Object,
      default: () => {}
    }
  },

  render() {
    const slots = this.$slots.default;
    return slots ? slots[0] : null
  },

  methods: {
    setup() {
      this.$nextTick(() => {
        let slots = this.$slots.default;
        if (slots && slots.length) {
          new ObserverTracker(slots[0].elm, Object.assign({}, this.options, {
            onVisible: d => this.$emit('visible', d)
          }));
        }
      });
    }
  },

  mounted() {
    this.setup();
  }
}

const VueObserverTracker = function install(Vue) {
  Vue.component('observer-tracker', ObserverTrackerComponent);
};

export default VueObserverTracker;
